<template>
  <div>
    <page-loading v-if="!item" />
    <page-title v-if="item" :title="pageTitle" />
    <b-tabs content-class="mt-3" v-if="item" v-model="tabIndex">
      <b-tab title="User">
        <application-user-fields :item="item" v-on:submit="onSubmit" v-on:cancel="onCancel">
          <template v-slot:save>Save</template>
          <template v-slot:buttons>
            <b-button-group class="mx-2">
              <b-button type="button" @click="onReset">Send Password Reset</b-button>
            </b-button-group>
            <b-button-group>
              <b-button type="button" variant="danger" @click="onDelete">Delete</b-button>
            </b-button-group>
          </template>
        </application-user-fields>
      </b-tab>
      <b-tab title="Roles">
        <application-user-role-list :application-user-id="item.id" v-if="item" :is-editable="isEditable">
        </application-user-role-list>
      </b-tab>
      <b-tab title="Subscriptions">
        <application-user-subscription-list :application-user-id="item.id" v-if="item">
        </application-user-subscription-list>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'

export default {
  name: "ApplicationUserEdit",
  mixins: [CrudOperationsMixin],
  props: ['id'],
  data() {
    return {
      item: null,
      tabIndex: 0,
      tabIds: ['#user', '#roles', '#subscriptions']
    };
  },
  computed: {
    pageTitle: function () {
      return 'User: ' + this.item.userName;
    },
    isEditable: function () {
      return this.$root.$data.authenticatedUser.roles.some(x => x == "SiteAdmin") || this.$root.$data.authenticatedUser.stationRoles.some(x => x.station.id == this.$route.params.id && x.type == "STATION_HEAD");
    },
  },
  methods: {
    load: function () {

      this.readQuery('/graphql/management', {
          query: `
            query ($id: ID) {
              applicationUser (id: $id) {
                id,
                address1,
                address2,
                city,
                country,
                email,
                firstName,
                isCertified,
                lastName,
                organization,
                phoneNumber,
                postalCode,
                sendMarketingEmails,
                state,
                userName,
                subscriptions {
                  station {
                    id,
                    name
                  }
                }
              }
            }`,
          variables: {
            'id': this.id
          }
        }, (data) => {
          this.item = data.applicationUser;
          this.tabIndex = this.tabIds.findIndex(tab => tab === this.$route.hash);
        });
    },
    onCancel(evt) {
      this.$router.go(-1);
    },
    onSubmit(evt) {
      this.updateQuery('/graphql/management', {
        query: `
          mutation ($applicationUser: EditApplicationUserInputOGT!) {
            editApplicationUser(applicationUser: $applicationUser) {
              id
            }
          }`,
        variables: {
          'applicationUser': {
            applicationUserId: this.item.id,
            email: this.item.email,
            firstName: this.item.firstName,
            lastName: this.item.lastName,
            organization: this.item.organization,
            address1: this.item.address1,
            address2: this.item.address2,
            city: this.item.city,
            state: this.item.state,
            postalCode: this.item.postalCode,
            country: this.item.country,
            phoneNumber: this.item.phoneNumber,
            isCertified: this.item.isCertified,
            sendMarketingEmails: this.item.sendMarketingEmails
          }
        }}, () => {
          this.$router.push('/applicationUser');
        }, null, 'User', this.item.userName);
    },
    onDelete(evt) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete this user? "' + this.item.userName + '" will no longer be able to log in.', {
        title: 'Delete User',
        okVariant: 'danger',
        okTitle: 'Yes',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if (!value)
          return;

        this.deleteQuery('/graphql/management', {
          query: `
            mutation ($applicationUser: DeleteApplicationUserInputOGT!) {
              deleteApplicationUser(applicationUser: $applicationUser) {
                id
              }
            }`,
          variables: {
            'applicationUser': {
              applicationUserId: this.item.id
            }
          }}, () => {
            this.$router.push('/applicationUser');
          }, null, 'User', this.item.userName);
      });
    },
    onReset(evt) {
      this.query('/graphql/public', {
        query: `
          mutation ($forgotPassword: ForgotPasswordInputOGT!) {
            forgotPassword(forgotPassword: $forgotPassword) {
              email
            }
          }`,
        variables: {
          'forgotPassword': { 
            "userNameOrEmail": this.item.userName
          }
        }}, (data) => {
        }, null, 'Password Reset Email Sent', 'Error Sending Password Reset Email', 'A password reset email was sent to ' + this.item.email + '.');
    }
  },
  mounted () {
    this.load();
    // Use this instead of the previous line to test the "Loading" bar
    //window.setTimeout(this.load, 3000);
  }
};
</script>